//
//
//
//
//
//
//
//
//

import { SET_COOKIE_BANNER_HIDDEN } from '~/store/mutationTypes';

export default {
    /** @return {import('vue-meta').MetaInfo} */
    head() {
        return this.$nuxtI18nHead({ addSeoAttributes: true });
    },
    methods: {
        onCookieBannerHidden() {
            this.$store.commit(SET_COOKIE_BANNER_HIDDEN);
        },
        /**
         * @param {string} key
         * @return {string} The cookie translation.
         */
        getCookieTranslation(key) {
            return /** @type {string} */ (this.$t(`webCommon.cookie.${key}`));
        },
    },
};
